import { connect } from '@seedcloud/stateless'
import { useLayoutEffect } from 'react'
import { useHistory } from 'react-router-dom'

import { CompanyListItem } from './CompanyListItem'
import { FilterInput } from './FilterInput'
import { TypeGroupSelectField } from './TypeGroupSelectField'

import { Loader } from 'components/common/Loader'
import { Spinner } from 'components/common/Spinner'
import { styled, apply } from 'lib/styled'
import {
  companyModule,
  companyList$,
  inspectedEntity$,
  isLoadingCompany$,
} from 'modules/legacy-company'

const Container = styled.div(
  apply('flex flex-column w-1/4 min-w-10 max-w-24 mr-6 bg-white rounded-lg shadow-sm', {
    overflow: 'hidden',
  })
)

const FilterContainer = styled.div(
  apply('p-4 border-0 border-b-1 border-solid border-grey-lighter')
)
const InputContainer = styled.div(apply('flex mb-4'))

const List = styled.ol(
  apply('p-0 m-0', {
    overflow: 'auto',
    listStyleType: 'none',
  })
)

const ConnectedCompanyList = connect(() => ({
  companyList: companyList$,
  isLoadingCompany: isLoadingCompany$,
  inspectedEntity: inspectedEntity$,
}))(CompanyList)

const { fetchCompanies } = companyModule

function CompanyList({ companyList, isLoadingCompany, inspectedEntity, ...props }) {
  const history = useHistory()

  useLayoutEffect(() => {
    fetchCompanies(null)
  }, [])

  return (
    <Container {...props}>
      <FilterContainer>
        <InputContainer>
          <FilterInput containerProps={{ style: apply('flex-1') }} />
        </InputContainer>

        <TypeGroupSelectField />
      </FilterContainer>

      <Loader
        loading={isLoadingCompany}
        renderPlaceholder={<Spinner size={32} thickness={6} style={apply('mt-4')} />}
      >
        <List>
          {companyList.map((company) => {
            const isInspected = company.id === inspectedEntity

            const onInspectCompany = () => {
              history.push(`/companies/${company.id}`)
            }

            return (
              <CompanyListItem
                key={company.id}
                isInspected={isInspected}
                company={company}
                onClick={onInspectCompany}
              />
            )
          })}
        </List>
      </Loader>
    </Container>
  )
}

export { ConnectedCompanyList as CompanyList }
